<template>
  <div :class="cn('skeleton rounded-md', props.class)" />
</template>

<script setup>
import { cn } from '@/lib/utils'
const props = defineProps({ class: { type: String, default: '' } })
</script>
